import { ProcessUserData } from "./ProcessUserData";

const auth = {
    ProcessUserData,
}

export default auth;
